import { doc, getDoc, onSnapshot } from "firebase/firestore";
import { db } from "../firebase";

export type FeatureFlags = {
  familyCrmEnabled: boolean;
};

export const DEFAULT_FEATURE_FLAGS: FeatureFlags = {
  familyCrmEnabled: false,
};

export function normalizeFeatureFlags(data: any): FeatureFlags {
  return {
    familyCrmEnabled: data?.familyCrmEnabled === true,
  };
}

export async function loadFeatureFlags(): Promise<FeatureFlags> {
  const snap = await getDoc(doc(db, "settings", "featureFlags"));
  return normalizeFeatureFlags(snap.exists() ? snap.data() : {});
}

export function subscribeFeatureFlags(callback: (flags: FeatureFlags) => void) {
  return onSnapshot(
    doc(db, "settings", "featureFlags"),
    (snap) => callback(normalizeFeatureFlags(snap.exists() ? snap.data() : {})),
    () => callback(DEFAULT_FEATURE_FLAGS)
  );
}
